import { ACCESS_LEVELS, FEATURE_FLAGS } from '@/lib/consts.js'
import { __t } from '@/lib/helpers.js'
import { ROUTE_META_PARAMS } from '@/router/consts.js'
import { useEppo } from '@/composables/eppo'

export default {
  path: 'loyalty-program',
  name: 'settings.loyalty-program',
  meta: {
    title: __t('routes.settings.loyalty-program.title'),
    subtitle: __t('routes.settings.loyalty-program.subtitle'),
    icon: 'booksy-app',
    [ROUTE_META_PARAMS.FEATURE_FLAG_EPPO]: FEATURE_FLAGS.LoyaltyProgram,
    [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.MANAGER,
    [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: () => !useEppo().ff(FEATURE_FLAGS.Feature_RelocateLoyaltyProgramTile),
  },
  component: () => import('@/views/business/settings/loyalty-program/index.vue'),
  children: [
    {
      path: 'program',
      name: 'settings.loyalty-program.program',
      meta: {
        title: __t('routes.settings.loyalty-program.program.title'),
        subtitle: __t('routes.settings.loyalty-program.program.subtitle'),
        [ROUTE_META_PARAMS.HIDDEN_IN_SEARCH]: true,
      },
      component: () => import('@/views/business/settings/loyalty-program/program.vue'),
    },
    {
      path: 'cards',
      name: 'settings.loyalty-program.cards',
      meta: {
        title: __t('routes.settings.loyalty-program.cards.title'),
        subtitle: __t('routes.settings.loyalty-program.cards.subtitle'),
        defaultSubroute: {
          name: 'settings.loyalty-program.cards.list',
        },
        [ROUTE_META_PARAMS.HIDDEN_IN_SEARCH]: true,
      },
      component: () => import('@/views/business/settings/loyalty-program/index.vue'),
      children: [
        {
          path: '',
          name: 'settings.loyalty-program.cards.list',
          meta: {
            title: __t('routes.settings.loyalty-program.cards.title'),
            [ROUTE_META_PARAMS.HIDDEN_IN_SEARCH]: true,
          },
          component: () => import('@/views/business/settings/loyalty-program/card-list.vue'),
        },
        {
          path: 'card-edit/:cardId?',
          name: 'settings.loyalty-program.cards.card-edit',
          meta: {
            title: __t('routes.settings.loyalty-program.cards.title'),
            [ROUTE_META_PARAMS.HIDDEN_IN_SEARCH]: true,
          },
          component: () => import('@/views/business/settings/loyalty-program/card-form.vue'),
        },
      ],
    },
  ],
}
